import { QueryClient } from '@tanstack/react-query'

// Module-level so non-component code (e.g. the auth flow) can clear the cache.
export const queryClient = new QueryClient()
